// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"282":"0ca5fc","380":"9ab86f","522":"5d433a","722":"9e44f7","841":"724800"}[chunkId] + ".js";
};